import { multicast } from "rxjs/operators";
import { finalizeWithKind } from "./finalizeWithKind";
export function multicastWithKind(factory, selector) {
    return (source) => {
        let kind = undefined;
        let subject = undefined;
        return source.pipe(finalizeWithKind((k) => (kind = k)), multicast(() => {
            subject = factory(kind, subject);
            kind = undefined;
            return subject;
        }, selector));
    };
}
//# sourceMappingURL=multicastWithKind.js.map